import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'call-to-action',
  templateUrl: './call-to-action.component.html',
  styleUrls: ['./call-to-action.component.scss']
})
export class CallToActionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
